"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[1598],{

/***/ 93716:
/***/ ((module) => {

module.exports = {"id":"loki"};

/***/ })

}]);